import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL } from './CTAButton';
import { PRICE } from './salesData';
import { trackInitiateCheckout } from '../utils/metaPixel';

/**
 * Barra de compra fija para móvil. Aparece SOLO cuando el visitante llega a la
 * sección central de precio (la primera revelación del precio) y queda
 * disponible desde ahí hasta el final de la página.
 */
export function StickyBuyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let frame = 0;
    const update = () => {
      frame = 0;
      const offer = document.getElementById('oferta');
      // Aparece al llegar a la sección central de precio y se mantiene
      // disponible desde ahí hasta el final de la página.
      const offerReached = offer ? offer.getBoundingClientRect().top < window.innerHeight * 0.4 : false;
      setVisible(offerReached);
    };
    const onScroll = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };
    update();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <div aria-hidden={!visible} className={`fixed inset-x-0 bottom-0 z-40 border-t border-warm bg-cream/97 backdrop-blur transition-transform duration-200 ease-out md:hidden ${visible ? 'translate-y-0' : 'pointer-events-none translate-y-full'}`} style={{
    paddingBottom: 'env(safe-area-inset-bottom)'
  }} data-id="element-338" data-mp="2n6xod3aszm2p">
      <div className="flex items-center justify-between gap-3 px-5 py-2.5" data-id="element-339" data-mp="36506qz8uikrj">
        <div className="min-w-0" data-id="element-340" data-mp="362w5yq68u1vh">
          <p className="truncate font-sans text-[0.6rem] font-semibold uppercase tracking-[0.14em] text-charcoal/50" data-id="element-341" data-mp="17pnhi6mll8i7">
            100 recetas · 2 tomos
          </p>
          <p className="font-display font-display-black text-[1.35rem] leading-tight tabular-nums text-charcoal" data-id="element-342" data-mp="1bt1xwyeg7qw6">
            <span className="align-top font-display text-[0.6rem] font-bold text-caramel" data-id="element-343" data-mp="2f3ps5zh72vyd">
              {PRICE.currency}{' '}
            </span>
            {PRICE.current}
          </p>
        </div>
        <a href={CHECKOUT_URL} onClick={() => trackInitiateCheckout()} tabIndex={visible ? 0 : -1} className="flex min-h-[48px] max-w-[11.5rem] shrink-0 items-center justify-center rounded-full bg-[#F47A2A] px-5 py-2 text-center font-sans text-[0.64rem] font-bold uppercase leading-[1.15] tracking-[0.08em] text-white shadow-[0_12px_22px_-12px_rgba(244,122,42,0.6)] transition-colors duration-200 ease-out hover:bg-[#DF6A1D] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#F47A2A]/50" data-id="element-344" data-mp="2k0zgfbsul1km">
          Quiero hacer estas cookies
        </a>
      </div>
    </div>;
}